module.exports = __webpack_public_path__ + "img/Appstore.ed63e5a4.png";